/*
 * @Author: Teemo Ding
 * @Date: 2021-08-06 14:25:37
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-09 17:01:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDatabaseSettings/Gender/index.tsx
 */
import { Button } from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import EditDraggableTable from '@/src/components/DroppableTable/EditDraggableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { randomNumber } from '@/src/tools/helper';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { genderColumns } from '../config';
import css from '../css.module.less';

const Gender = ({ form, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const addGender = (_, add) => {
    const gender = form.getFieldValue('genders');
    const keys = gender.map((item, index) => ['genders', index, 'value']);
    form.validateFields(keys).then(() => {
      add({ value: '', uuid: randomNumber(), open: true });
    });
  };

  const onChange = (e, value, move) => {
    const { from, to } = value;
    move(from, to);
  };

  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={css.databaseSettingTableContainer}
        title={getI18n(
          'customerDatabaseSetting.customerDatabaseSettings_config.gender',
        )}>
        <Form.List name='genders'>
          {(fields, { add, move, remove }) => (
            <Fragment>
              <EditDraggableTable
                hideAllDragHandlers={disabled}
                id='genderTable'
                dataSource={fields}
                columns={genderColumns(fields, remove, form, disabled, {
                  getI18n,
                })}
                rowKey='uuid'
                pagination={false}
                onTableChange={(e, value) => {
                  if (onChange) onChange(e, value, move);
                }}
              />
              <div className={css.addBtn}>
                <Button
                  type='primary'
                  onClick={() => addGender(fields, add)}
                  disabled={disabled}>
                  {getI18n('customerDatabaseSetting.gender.addAvailableOption')}
                </Button>
              </div>
              <Configuration
                configStart={getI18n(
                  'customerDatabaseSetting.customerTitle.configStart',
                )}
                // linkTo={`/settings/payment`}
                configLink=' '
                configEnd={getI18n(
                  'customerDatabaseSetting.customerTitle.configEnd',
                )}
                hideGt
              />
            </Fragment>
          )}
        </Form.List>
      </SectionWrapper>
    </div>
  );
};

export default Gender;
